import Axios from 'axios';
import setup from './axios.setup';

export const API_DEFAULT_ROOT = window.location.origin;
export const API_DEFAULT_BASE = '/api/v1';

const options = {
  baseURL: `${API_DEFAULT_ROOT}${API_DEFAULT_BASE}`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
};

// setup
export const apiv1A = Axios.create(options);
export const apiv1B = Axios.create(options);

setup(apiv1A); // with loading
setup(apiv1B, true); // without loading
